import { Controller } from '@hotwired/stimulus';

export default class StickySubscribeController extends Controller {
  static targets = ['anchor', 'stickyBtn']

  connect() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.stickyBtnTarget.classList.toggle(
          'slide-from-bottom--visible',
          !entry.isIntersecting
        )
      },
      { threshold: 0 }
    )
    this.observer.observe(this.anchorTarget)
  }

  removeFocus() {
    document.activeElement.blur()
  }

  disconnect() {
    this.observer.disconnect()
  }
}
